import * as React from 'react'
import { FormattedDateTime } from 'components/formatted-datetime'
import { WinCreatedNotification } from '../../../../store/modules/notifications'

export type WinCreatedContentProps = {
  notification: WinCreatedNotification
}

export const WinCreatedContent: React.VFC<WinCreatedContentProps> = (props) => {
  const { notification } = props

  const isNote = notification.resourceName === 'Note'

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        <strong className="font-bold">
          {notification.author ? notification.author.fullName : 'Someone'}
        </strong>{' '}
        {isNote ? 'gave you a note' : 'gave you a win'}
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">
          View your {isNote ? 'note' : 'win'}
        </span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
